import React, { useState } from "react";
import {
  Title,
  Select,
  GoBack,
  TextArea,
  MyMessage,
  PhoneInput,
  InputField,
  DashboardIntro,
  MyActionButton,
  MyButton,
} from "../../home/component/Component";
import { codeOk } from "../../../middlewares/index";
import { BreadCrumbComponent } from "../../../middlewares/breadCrumb/BreadCrumbComponent";
import { useDoSeeDataContext } from "../../../context/doSeeData/DoSeeDataContext";
import { getOneSafari } from "../../../middlewares/sysNavigation/SysNavigation";
import { FOLDERS, image_kit_folder } from "../utils/Utils";
import { ImageKitUpload } from "../../../middlewares/libraries/imageKit/ImageKitLibrary";
import { defaultImage } from "../../../middlewares/libraries/imageKit/ImageKit";
import { useGeoPositionContext } from "../utils/geoPosition";
import { _TYPES_ } from "../utils/types";
import BestTimeToVisit from "../../home/component/BestTimeToVisit";
import Pricing from "../../home/component/Pricing";
import GenerateDescription from "../utils/GenerateDescription";

const Edit = () => {
  const { updateOneContent } = useDoSeeDataContext();
  const safari = getOneSafari();
  const {
    country_id,
    entry_label,
    country_name,
    first_level_id,
    fourth_level_id,
    second_level_id,
    third_level_id,
  } = useGeoPositionContext();

  const [error, setError] = useState(false);
  const [message, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const safari_id = safari?.safari_id;
  const [thumbnail, setThumbnail] = useState(safari?.thumbnail);
  const [thumbnailId, setThumbnailId] = useState(safari?.image_cdn_id);
  const [title, setTitle] = useState(safari?.title);
  const [venue, setVenue] = useState(safari?.venue);
  const [openDays, setOpenDays] = useState(safari?.opened_days);
  const [openedAt, setOpenedAt] = useState(safari?.opened_at);
  const [closedAt, setClosedAt] = useState(safari?.closed_at);
  const [email, setEmail] = useState(safari?.email_address);
  const [payLink, setPayLink] = useState(safari?.pay_link);
  const [phoneNumber, setPhoneNumber] = useState(safari?.phone_number);
  const [whatsapp, setWhatsapp] = useState(safari?.whatsapp);
  const [facebook, setFacebook] = useState(safari?.facebook);
  const [twitter, setTwitter] = useState(safari?.twitter);
  const [instagram, setInstagram] = useState(safari?.instagram);
  const [youtube, setYoutube] = useState(safari?.youtube);
  const [hashtags, setHashtags] = useState(safari?.hashtag);
  const [formattedAddress, setFormattedAddress] = useState(
    safari?.formatted_address
  );
  const [featured, setFeatured] = useState(safari?.featured);
  const [promoted, setPromoted] = useState(
    safari?.promoted ? safari?.promoted : "no"
  );
  const [safariStatus, setEventStatus] = useState(safari?.status);
  const [description, setDescription] = useState(safari?.description);
  const [expo, setExpo] = useState(safari?.expo);
  const [showTop, setShowTop] = useState(safari?.show_top);
  const [bestTime, setBestTime] = useState(
    safari?.best_time_to_visit ? safari?.best_time_to_visit : []
  );
  const [pricing, setPricing] = useState(safari?.Pricings);
  const [showDescriptionModal, setShowDescriptionModal] = useState(null);

  const safariRoutes = "/data/safari";

  const responses = (isError, message) => {
    setError(isError);
    setLoading(false);
    setSuccess(!isError);
    setErrorMessage(message);
  };

  const updateOneEventHandler = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (!thumbnail || !thumbnailId) {
      responses(true, "Image Required");
    } else {
      await sendDBRequest();
    }
  };

  /**
   * @author Ntavigwa Bashombe
   * @param {*} thumbnail
   * @returns
   */
  const sendDBRequest = async () => {
    const data = {
      country_id: country_id ? country_id : safari?.country_id,
      first_level_id: first_level_id ? first_level_id : 0,
      second_level_id: second_level_id ? second_level_id : 0,
      third_level_id: third_level_id ? third_level_id : 0,
      fourth_level_id: fourth_level_id ? fourth_level_id : 0,
      title: title,
      slug: title?.toLowerCase().replace(/\s/g, "_"),
      description: description,
      city_level: "level",
      venue: venue,
      opened_days: openDays,
      opened_at: openedAt,
      closed_at: closedAt,
      thumbnail: thumbnail ? thumbnail : defaultImage,
      image_cdn_id: thumbnailId ? thumbnailId : "",
      phone_number: phoneNumber,
      email_address: email,
      pay_link: payLink,
      whatsapp: whatsapp,
      facebook: facebook,
      twitter: twitter,
      instagram: instagram,
      youtube: youtube,
      hashtag: hashtags,
      audio_ad: "none",
      formatted_address: formattedAddress,
      country_short: "none",
      status: safariStatus,
      featured: featured,
      promoted: promoted,
      expo: expo,
      show_top: showTop,
      best_time_to_visit: bestTime?.length > 0 ? String(bestTime) : null,
      pricing: pricing,
    };

    const { message, status } = await updateOneContent({
      data_id: safari_id,
      data: data,
      content: _TYPES_.SAFARI,
      position: {
        country_id,
        first_level_id,
        second_level_id,
        third_level_id,
        fourth_level_id,
      },
    });

    if (status === codeOk) responses(false, message);
    else responses(true, message);
  };

  // --- Design tokens (compact & consistent) ---
  const container = "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8";
  const pageBg = "bg-slate-50";
  const card =
    "overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm";
  const sectionPad = "p-4 sm:p-5";
  const grid3 = "grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4 w-full";
  const grid3Lg = "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 w-full";
  const grid4 =
    "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 w-full";
  const btnPrimary =
    "inline-flex items-center gap-2 px-4 py-2.5 rounded-lg bg-blue-700 text-white hover:bg-blue-600 focus-visible:ring-2 focus-visible:ring-blue-600 focus-visible:ring-offset-2";
  // --------------------------------------------

  return (
    <div className={`h-full overflow-y-auto ${pageBg}`}>
      <div className={`${container} py-4 lg:py-6`}>
        <div className="mb-3">
          <BreadCrumbComponent />
        </div>

        <div className="flex items-center justify-between mb-2">
          <GoBack props={{ route: safariRoutes }} />
        </div>

        <div className="mb-4">
          <DashboardIntro props={{ intro: `Edit Safari`, name: entry_label }} />
        </div>

        <form onSubmit={updateOneEventHandler} className="space-y-4">
          {/* Alerts */}
          <div className={`${card} ${sectionPad}`}>
            <MyMessage
              error={error}
              message={message}
              success={success}
              onExpired={() => {
                setError(false);
                setSuccess(false);
              }}
              onClick={() => {
                setError(false);
                setSuccess(false);
                setErrorMessage("");
              }}
            />
          </div>

          {/* Media */}
          <div className={`${card} ${sectionPad}`}>
            <ImageKitUpload
              thumbnail={thumbnail}
              thumbnailId={thumbnailId}
              setThumbnail={setThumbnail}
              setThumbnailId={setThumbnailId}
              folder={image_kit_folder(country_name, FOLDERS.SAFARI)}
            />
          </div>

          {/* Details & Best Time */}
          <div className={`${card} ${sectionPad} space-y-4`}>
            <Title props={{ title: "Event Details" }} />

            <div className="w-full">
              <p className="text-xs font-semibold text-slate-700 mb-2">
                Best Time To Visit
              </p>
              <BestTimeToVisit bestTime={bestTime} setBestTime={setBestTime} />
            </div>

            <div className={grid3}>
              <InputField
                props={{
                  id: "title",
                  title: "Title",
                  type: "text",
                  value: title ? title : "",
                  onChange: (e) => {
                    setTitle(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <Select
                props={{
                  id: "top",
                  title: "Show In Top Safari",
                  option: ["no", "yes"],
                  preselect:
                    showTop !== null
                      ? [{ name: showTop === 0 ? "no" : "yes" }]
                      : null,
                  onChange: (e) => {
                    if (e.target.selectedIndex === 0) setShowTop(0);
                    else setShowTop(1);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <InputField
                props={{
                  id: "venue",
                  title: "Venue",
                  type: "text",
                  value: venue ? venue : "",
                  onChange: (e) => {
                    setVenue(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <InputField
                props={{
                  id: "formatted_address",
                  title: "Formatted Address",
                  type: "address",
                  value: formattedAddress ? formattedAddress : "",
                  onChange: (e) => {
                    setFormattedAddress(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
            </div>
          </div>

          {/* Date & Time */}
          <div className={`${card} ${sectionPad} space-y-4`}>
            <Title props={{ title: "Date & Time" }} />
            <div className={grid3Lg}>
              <InputField
                props={{
                  id: "opened_days",
                  title: "Open Days",
                  type: "text",
                  value: openDays ? openDays : "",
                  onChange: (e) => {
                    setOpenDays(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <InputField
                props={{
                  id: "opened_at",
                  title: "Opened At",
                  type: "time",
                  value: openedAt ? openedAt : "",
                  onChange: (e) => {
                    setOpenedAt(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <InputField
                props={{
                  id: "closed_at",
                  title: "Closed At",
                  type: "time",
                  value: closedAt ? closedAt : "",
                  onChange: (e) => {
                    setClosedAt(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
            </div>
          </div>

          {/* Pricing */}
          <div className={`${card} ${sectionPad} space-y-4`}>
            <Title props={{ title: "Pricing" }} />
            <Pricing pricing={pricing} setPricing={setPricing} />
          </div>

          {/* Contact Info */}
          <div className={`${card} ${sectionPad} space-y-4`}>
            <Title props={{ title: "Contact Info" }} />
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full">
              <div className="flex justify-center items-center">
                <PhoneInput
                  setPhone={setPhoneNumber}
                  phone={phoneNumber}
                  required={false}
                />
              </div>
              <InputField
                props={{
                  id: "email",
                  title: "Email Address",
                  type: "email",
                  value: email ? email : "",
                  onChange: (e) => {
                    setEmail(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <InputField
                props={{
                  id: "pay-link",
                  title: "Pay Link (Optional)",
                  type: "text",
                  value: payLink ? payLink : null,
                  onChange: (e) => {
                    setPayLink(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
            </div>
          </div>

          {/* Social Contact */}
          <div className={`${card} ${sectionPad} space-y-4`}>
            <Title props={{ title: "Social Contact" }} />
            <div className={grid4}>
              <InputField
                props={{
                  id: "whatsapp",
                  title: "Whatsapp",
                  type: "text",
                  value: whatsapp ? whatsapp : "",
                  onChange: (e) => {
                    setWhatsapp(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <InputField
                props={{
                  id: "facebook",
                  title: "Facebook",
                  type: "text",
                  value: facebook ? facebook : "",
                  onChange: (e) => {
                    setFacebook(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <InputField
                props={{
                  id: "twitter",
                  title: "Twitter",
                  type: "text",
                  value: twitter ? twitter : "",
                  onChange: (e) => {
                    setTwitter(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <InputField
                props={{
                  id: "instagram",
                  title: "Instagram",
                  type: "text",
                  value: instagram ? instagram : "",
                  onChange: (e) => {
                    setInstagram(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <InputField
                props={{
                  id: "youtube",
                  title: "YouTube",
                  type: "text",
                  value: youtube ? youtube : "",
                  onChange: (e) => {
                    setYoutube(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
            </div>
          </div>

          {/* More Settings */}
          <div className={`${card} ${sectionPad} space-y-4`}>
            <Title props={{ title: "More Settings" }} />
            <div className={grid3Lg}>
              <Select
                props={{
                  id: "safari_status",
                  title: "Status",
                  option: ["visible", "invisible"],
                  preselect:
                    safariStatus !== null
                      ? [{ name: safariStatus === 1 ? "visible" : "invisible" }]
                      : null,
                  onChange: (e) => {
                    if (e.target.selectedIndex === 0) setEventStatus(1);
                    else setEventStatus(0);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <Select
                props={{
                  id: "featured",
                  title: "Featured",
                  option: ["no", "yes"],
                  preselect: featured !== null ? [{ name: featured }] : null,
                  onChange: (e) => {
                    setFeatured(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <Select
                props={{
                  id: "promoted",
                  title: "Promoted",
                  option: ["no", "yes"],
                  preselect: promoted !== null ? [{ name: promoted }] : null,
                  onChange: (e) => {
                    setPromoted(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <Select
                props={{
                  id: "gallery",
                  title: "Show in Gallery",
                  option: ["no", "yes"],
                  preselect:
                    expo !== null
                      ? [{ name: expo === 0 ? "no" : "yes" }]
                      : null,
                  onChange: (e) => {
                    const choice = e.target.value;
                    setExpo(choice === "no" ? 0 : 1);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
            </div>
          </div>

          {/* Description */}
          <div className={`${card} ${sectionPad} space-y-4`}>
            <div className="flex items-center justify-between">
              <Title props={{ title: "Description" }} />
              <MyButton
                onClick={() => setShowDescriptionModal(true)}
                className={btnPrimary}
              >
                Generate Description
              </MyButton>
            </div>
            <TextArea
              props={{
                id: "description",
                title: "Description",
                type: "text",
                value: description ? description : "",
                onChange: (e) => {
                  setDescription(e.target.value);
                  setError(null);
                  setSuccess(null);
                },
              }}
            />
          </div>

          {/* Tags + Submit */}
          <div className={`${card} ${sectionPad} space-y-4`}>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full">
              <InputField
                props={{
                  id: "hashtag",
                  title: "Tags (comma separated)",
                  type: "text",
                  value: hashtags ? hashtags : "",
                  onChange: (e) => {
                    setHashtags(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
            </div>

            <div className="pt-1">
              <MyActionButton
                loading={loading}
                title="Save Changes"
                onClick={() => {
                  setError(false);
                  setSuccess(false);
                  setErrorMessage(null);
                }}
              />
            </div>
          </div>
        </form>
      </div>

      {showDescriptionModal ? (
        <GenerateDescription
          setDescription={setDescription}
          setShowDescriptionModal={setShowDescriptionModal}
        />
      ) : null}
    </div>
  );
};

export default Edit;
